<script setup lang="ts">
defineProps<{
	styleRetry: boolean;
}>();
</script>
<template>
	<svg class="nfc_ok" v-if="!styleRetry" viewBox="0 0 48 48" aria-hidden="true">
		<rect x="8" y="12" width="32" height="24" rx="4" ry="4" />
		<path d="M16 22h16m-10 6h6" />
	</svg>
</template>
